// extracted by mini-css-extract-plugin
export default {"productGrid":"A3-z","centerLink":"B3-z","productSection":"C3-z","item":"D3-z","ctaButton":"E3-z"};